import { useState, useEffect } from 'react';
import { 
    fetchFrontInboxes, 
    fetchFrontChannels, 
    fetchTeammateEmails 
} from '../api/suggestionService';

export const useEmailChannels = (userEmail) => {
    const [allInboxes, setAllInboxes] = useState([]);
    const [UserInboxes, setUserInboxes] = useState([]);
    const [allChannels, setAllChannels] = useState([]);
    const [inboxChannels, setInboxChannels] = useState([]);
    const [UserChannels, setUserChannels] = useState([]);
    const [isLoadingInboxes, setIsLoadingInboxes] = useState(false);
    const [isLoadingChannels, setIsLoadingChannels] = useState(false);
    const [isDefaultChannel, setIsDefaultChannel] = useState(false);
    const [channelInput, setChannelInput] = useState("");
    const [channelSuggestions, setChannelSuggestions] = useState([]);
    const [showChannelSuggestions, setShowChannelSuggestions] = useState(false);
    const [selectedChannelSuggestionIndex, setSelectedChannelSuggestionIndex] = useState(-1);
    const [teammateEmails, setTeammateEmails] = useState([]);
    const [showEmailField, setShowEmailField] = useState(false);

    useEffect(() => {
        if (!userEmail) return;

        setIsLoadingInboxes(true);
        fetchTeammateEmails().then(emails => {
            setTeammateEmails(emails);
        });

        fetchFrontInboxes(userEmail).then(inboxes => {
            setAllInboxes(inboxes);
            setUserInboxes(inboxes);
            setIsLoadingInboxes(false);
        });

        setIsLoadingChannels(true);
        fetchFrontChannels(userEmail).then(channels => {
            setAllChannels(channels);
            setUserChannels(channels);
            // Default channel will be set conditionally inside Submissionprogress.js when "sendingOption" changes
            setIsLoadingChannels(false);
        });
    }, [userEmail]);

    return {
        allInboxes, setAllInboxes,
        UserInboxes, setUserInboxes,
        allChannels, setAllChannels,
        inboxChannels, setInboxChannels,
        UserChannels, setUserChannels,
        isLoadingInboxes, setIsLoadingInboxes,
        isLoadingChannels, setIsLoadingChannels,
        isDefaultChannel, setIsDefaultChannel,
        channelInput, setChannelInput,
        channelSuggestions, setChannelSuggestions,
        showChannelSuggestions, setShowChannelSuggestions,
        selectedChannelSuggestionIndex, setSelectedChannelSuggestionIndex,
        teammateEmails, setTeammateEmails,
        showEmailField, setShowEmailField
    };
};
